import script from "./TestimonialsEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonialsEditor.vue?vue&type=script&setup=true&lang=js"

import "./TestimonialsEditor.vue?vue&type=style&index=0&id=11b50648&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11b50648"]])

export default __exports__